import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DecisionTransportService {
  decisionEvent: EventEmitter<boolean | string | number> = new EventEmitter();

  decisionTriggered(decision: boolean | string | number) {
    this.decisionEvent.emit(decision);
  }
}
